var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 17,
    viewBox: "0 0 20 17",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h20v17h-20z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h20v17h-20z",
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#464d57"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.0213 1.67004c-4.26666 0-8.06385 2.70213-10.0213 6.40575 2.02128 3.78571 5.68085 6.40571 10.0213 6.40571 4.2666 0 7.9827-2.5796 9.9787-6.40571-1.996-3.82539-5.7121-6.40575-9.9787-6.40575zm0 10.40936c-2.29664 0-4.15791-1.7922-4.15791-4.00361s1.86127-4.00362 4.15791-4.00362c2.2966 0 4.1579 1.79221 4.1579 4.00362s-1.8613 4.00361-4.1579 4.00361z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.0212 10.6964c1.4924 0 2.7021-1.16487 2.7021-2.60185 0-1.43697-1.2097-2.60187-2.7021-2.60187-1.49232 0-2.70211 1.1649-2.70211 2.60187 0 1.43698 1.20979 2.60185 2.70211 2.60185z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eye-open.a3f2c6cf01480b179a554a85af390a5b.svg";
export { ForwardRef as ReactComponent };